import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ModalController, ToastController } from "@ionic/angular";
import { PrintFileStatus } from 'src/app/shared-lib/domains/product';
import { CartService } from '../../shared/cart.service';
import { CancellingUploadsModalComponent } from "../cancelling-uploads-modal/cancelling-uploads-modal.component";

@Component({
  selector: 'app-uploading-files-modal',
  templateUrl: './uploading-files-modal.component.html',
  styleUrls: ['./uploading-files-modal.component.scss'],
  standalone: false
})
export class UploadingFilesModalComponent implements OnInit {

  @Input() files = [];
  printProduct;
  private progressInterval: any;
  uploadedFiles = 0;
  progress = 0;
  progressText = '';

  randomProgressTexts = [
    'Vamos, que empieza lo bueno',
    'Esto va cogiendo ritmo...',
    'Esto ya huele a tinta',
    'Desempolvando apuntes...',
    'Esto quedaría genial con las anillas de purpurina 🤩',
    'Casi, casi... no parpadees'
  ];
  // Each phase has a progress threshold and a corresponding text
  progressTextPhases = [
    { progress: 0, text: '' },
    { progress: 30, text: '' },
    { progress: 60, text: '' }
  ];


  constructor(protected modalController: ModalController, private cartService: CartService, private destroyRef: DestroyRef,
    private toastController: ToastController) {
    this.cartService.activePrintItem$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(pp => {
      this.printProduct = pp;
    });
    this.setRandomProgressTexts();
    this.setProgressText();
  }

  ngOnInit() {
    this.files = this.files.filter(f => !f.isUploaded);
    this.progressInterval = setInterval(() => {
      this.calculateProgress();
    }, 200);
  }

  ngOnDestroy() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  }

  private async calculateProgress() {
    this.uploadedFiles = this.files.filter(f => f.isUploaded).length;
    this.progress = Math.round((this.uploadedFiles / this.files.length) * 100);
    const currentModal = await this.modalController.getTop();
    if (this.uploadedFiles === this.files.length && this.files.length > 0 && currentModal.component === UploadingFilesModalComponent) {
      clearInterval(this.progressInterval);
      setTimeout(() => {
        const failedFiles = this.printProduct.product.printingGroup.files.filter(f => f.status !== PrintFileStatus.FINISHED);
        setTimeout(async () => {
          const toast = await this.toastController.create({
            message: failedFiles.length === 0 ? 'Tus documentos se han subido con éxito' : 'Algunos archivos no se han' +
              ' podido subir, revísalos para continuar',
            color: failedFiles.length === 0 ? 'success' : 'danger',
            position: 'bottom',
            cssClass: "fitWidthToast",
            duration: 3000,
            icon: failedFiles.length === 0 ? 'assets/icon/circle-check.svg' : 'assets/icon/alert-red-circle.svg'
          });
          await toast.present();
          this.modalController.dismiss();
        }, 1000);
      }, 2000);
    }
    this.setProgressText();
  }

  async cancel() {
    if (this.progress === 100) {
      return;
    }
    const confirmationModal = await this.modalController.create({
      component: CancellingUploadsModalComponent,
      backdropDismiss: false,
      cssClass: 'auto-height medium-width'
    });
    await confirmationModal.present();
    const { data } = await confirmationModal.onDidDismiss();
    if (!data) {
      return;
    }
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    // Cerramos el modal y le pasamos el 'role' de 'cancel'
    this.modalController.dismiss(null, 'cancel');
  }

  private setProgressText() {
    if (this.files.length === 1 && this.progress === 0) {
      this.progressText = 'Subiendo tu archivo...';
      return;
    }
    if (this.progress === 100) {
      this.progressText = 'Ya está todo listo 😎';
      return;
    }
    if (this.progressTextPhases[0] && this.progress >= this.progressTextPhases[0].progress) {
      this.progressText = this.progressTextPhases[0].text;
      this.progressTextPhases.shift();
    }
  }

  private setRandomProgressTexts() {
    this.progressTextPhases.forEach(phase => {
      const randomIndex = Math.floor(Math.random() * this.randomProgressTexts.length);
      phase.text = this.randomProgressTexts[randomIndex];
      this.randomProgressTexts.splice(randomIndex, 1); // Remove the selected text to avoid duplicates
    });
  }
}
